// NPM Imports
import React, { Fragment, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import { UpgradeBadge, UpgradePopUp } from "../../../../commonComponents";

export default function DynamicFeildAttachWorkflowUpgrade(props) {
  const { entity } = props;
  const [showPopUp, togglePopUp] = useState(false);

  return (
    <Fragment>
      <div
        className="dynamicfieldlist-add-workflow"
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}
        data-test="attachworkflowbtn-add-workflow-button"
        role="button"
        tabIndex="0">
        <FontAwesomeIcon
          icon={["far", "network-wired"]}
          className="dynamicfieldlist-icon-plus"
        />
        <UpgradeBadge isPro />
        {entity.wfId ? "Workflow attached" : "Attach workflow"}
      </div>
      {showPopUp && (
        <UpgradePopUp
          featureName={props.featureName}
          onClose={() => togglePopUp(false)}
        />
      )}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFeildAttachWorkflow/DynamicFeildAttachWorkflowUpgrade.js